import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { allowBuyCredits } from "@/components/helpers/workspace/permissions";
import { Box, BoxProps, Flex } from "@/components/layout/flexbox";
import { Sparkles } from "@/components/pieces/sparkles";
import { CoachingCurrentUser, CoachingCustomer } from "@/types/users";

import { BannerButton, DarkBanner } from "./DarkBanner";

interface BuyCreditsBannerProps extends BoxProps {
  user: CoachingCurrentUser | CoachingCustomer;
  buyLink?: string;
}

export function BuyCreditsBanner({
  user,
  buyLink = "/buy",
  ...props
}: BuyCreditsBannerProps) {
  const { availableCredits } = user;
  return (
    <DarkBanner
      py={[24, 3]}
      pl={3}
      pr={[3, 4]}
      className="round-corners"
      backgroundColor="#FFF"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="space-between"
      {...props}
    >
      <Flex flexWrap="wrap" alignItems="center">
        <Flex width={["100%", "auto"]} justifyContent="center">
          <Sparkles
            minSize={10}
            maxSize={24}
            minDelay={50}
            maxDelay={1100}
            onTop={true}
          >
            <Box p={3}>
              <EmbedSvg src={CreditSVG} height={60} width={60} />
            </Box>
          </Sparkles>
        </Flex>
        <Box
          py={2}
          ml={[0, 3]}
          width={["100%", "auto"]}
          textAlign={["left", "inherit"]}
        >
          <Box fontSize={[20, 24]} color="#FFF" fontWeight={600}>
            Get more coaching credits
          </Box>
          <Box mt={1} color="rgba(255,255,255,0.7)">
            {parseFloat(availableCredits || "0") === 0
              ? "You need credits to work with your coach"
              : "Credits are used to work with your coach"}
          </Box>
        </Box>
      </Flex>
      <Flex
        alignItems="center"
        flexWrap="wrap"
        mt={[3, 0]}
        width={["100%", "auto"]}
      >
        {allowBuyCredits() && (
          <BannerButton to={buyLink}>Buy Credits</BannerButton>
        )}
        <Box mt={[3, 0]} ml={[0, 3]} width={["100%", "auto"]}>
          <BannerButton to="/referrals">Refer a Friend</BannerButton>
        </Box>
      </Flex>
    </DarkBanner>
  );
}
